<template>
  <omint-page>
    <Header name="Telemedicina" titleLabel="Telemedicina" backRoute="/" />

    <div v-if="mostrarIframe" class="iframe">
      <iframe :src="prontoAtendimento.Url" width="100%" height="100%" allow="camera; microphone" allowfullscreen />
    </div>

    <omint-page-content v-else>
      <CFlex direction="column" gap="16px">
        <!-- Consulta por telemedicina -->
        <omt-card>
          <OmtTypography as="h2-bold" mb="8px">Consulta por telemedicina</OmtTypography>
          <OmtTypography as="p1" color="var(--colors-light-primary-gray2)" mb="24px">
            Agende uma consulta e seja atendido em breve.
          </OmtTypography>
          <OmtButton variant="solid" w="100%" @click="irParaAgendamento"> Agendar consulta </OmtButton>
        </omt-card>

        <omt-card v-if="exibirProntoAtendimento" mt="20px">
          <CFlex v-if="possuiHorario" align="center" gap="8px" bg="#FDEFE3" borderRadius="8px" px="12px" py="8px">
            <OmtIcons name="clock" size="lg" color="#E1840E" />
            <OmtTypography as="p1" color="var(--colors-orange-500)" mb="0" ml="5px">
              Disponível das
              <strong>{{ prontoAtendimento.HorarioInicio }} às {{ prontoAtendimento.HorarioFim }}</strong>
            </OmtTypography>
          </CFlex>
          <OmtDivider mb="12px" />
          <OmtTypography as="h2-bold" mb="8px">Pronto atendimento digital</OmtTypography>
          <OmtTypography as="p1" color="var(--colors-light-primary-gray2)" mb="16px">
            Consulte especialistas em clínica médica e pediatria com atendimento imediato, sem sair de casa e sem
            precisar de agendamento.
          </OmtTypography>
          <OmtTypography as="p1" color="var(--colors-light-primary-gray2)" mb="16px">
            Tudo 100% on-line, com qualidade, privacidade e segurança.
          </OmtTypography>
          <OmtTypography as="p1" color="var(--colors-light-primary-gray2)" mb="24px">
            Indicado para situações agudas e de baixa complexidade.
          </OmtTypography>
          <OmtButton variant="solid" w="100%" :disabled="!possuiLink" @click="falarComMedico">
            Falar com um médico agora
          </OmtButton>
        </omt-card>
      </CFlex>
    </omint-page-content>

    <Footer v-if="!mostrarIframe" />
  </omint-page>
</template>

<script>
import { mapState } from "vuex";
import { ObterProntoAtendimentoEinstein } from "@/api/atendimento";
import Header from "@/components/Molecules/Header";
import Footer from "@/components/Molecules/Footer";

export default {
  name: "ProntoAtendimento",
  components: { Header, Footer },
  data() {
    return {
      prontoAtendimento: null,
      mostrarIframe: false
    };
  },
  computed: {
    ...mapState("saude", ["vinculo"]),
    exibirProntoAtendimento() {
      // O card só é exibido quando há regra de pronto atendimento configurada (horário retornado).
      return this.possuiHorario;
    },
    possuiHorario() {
      return !!this.prontoAtendimento?.HorarioInicio && !!this.prontoAtendimento?.HorarioFim;
    },
    possuiLink() {
      return !!this.prontoAtendimento?.Url;
    }
  },
  mounted() {
    this.carregarProntoAtendimento();
  },
  methods: {
    irParaAgendamento() {
      this.$router.push("/agendamento");
    },
    falarComMedico() {
      // Dentro do horário e com link gerado, substitui os cards pelo iframe do atendimento.
      if (!this.possuiLink) return;
      this.mostrarIframe = true;
    },
    async carregarProntoAtendimento() {
      this.$root.$emit("show-loading");
      try {
        const resp = await ObterProntoAtendimentoEinstein({ vinculo: this.vinculo });
        this.prontoAtendimento = resp && resp.HorarioInicio !== undefined ? resp : null;
      } catch (error) {
        window.$log.error("carregarProntoAtendimento", error);
        this.prontoAtendimento = null;
      }

      // Sem regra ativa (api não retornou horários): segue direto para o agendamento.
      if (!this.possuiHorario) {
        this.$router.replace("/agendamento");
        return;
      }

      this.$root.$emit("hide-loading");
    }
  }
};
</script>

<style scoped>
.iframe {
  height: calc(100vh - 146px);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1290px;
  margin: 0 auto;
  padding: 0;
  position: relative;
}
</style>
